<form [formGroup]="regConfig" class="airport_complete" *ngIf="hasViewList">
    <ul class="arpt_list">
        <div class="p-0" *ngFor="let item of getAirports">
            <li class="p-2" (click)="onAirportSelect(item, inputFor)">
                <h5 class="include">{{item.name}}</h5>
            </li>
        </div>
    </ul>
</form>